/* src/app/modules/shared/components/pagination/pagination.component.scss */
.direct-pagination {
  margin-bottom: 0;
}
.direct-pagination mat-form-field {
  max-width: 100px;
  margin: -10px 0 -10px;
  align-items: center;
}
/*# sourceMappingURL=pagination.component.css.map */
